import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Orders from './pages/Ordens/Orders';
import Vehicles from './pages/Vehicles/Vehicles';
import BrandsModels from './pages/BrandsModels/BrandsModels';
import PrintPage from './components/PrintableOrder/PrintableOrder';
import Clients from './pages/Costumers/Clients';
import { Drawer } from './components/Drawer';
import UserLogin from './pages/Login/UserLogin';
import './index.css';
import Home from './pages/Home';
import logo from './assets/fp-logo.png'
import { ReactNotifications } from 'react-notifications-component';

import 'react-notifications-component/dist/theme.css';
import Contacts from './pages/Contacts/Contacts';

const Layout = ({ children, open, setOpen }) => {
  const location = useLocation();
  const hideHeaderAndDrawer = location.pathname === '/' || location.pathname === '/login' || location.pathname === '/print';
  const historyRoute = localStorage.getItem("fphistory");

  return (
    <>
      {!hideHeaderAndDrawer && <Drawer open={open} setOpen={setOpen} />}
      {!hideHeaderAndDrawer && (
        <header className="header">
          <button
            style={{
              outline: 'none',
              background: 'transparent',
              border: 'none',
              color: 'white',
              fontSize: '26px',
              cursor: 'pointer',
              marginRight: '1rem',
              marginLeft: '1rem'
            }}
            onClick={() => {
              setOpen(true);
            }}
          >
            ☰
          </button>
          <img style={{ width: '2.9rem', marginTop: "5px", marginBottom: "5px" }} src={logo} alt="FP-Motor logo" />
          <h1 className="title" style={{ fontSize: "30px" }}>FP MotorHome - {historyRoute}</h1>
        </header>
      )}

      <main className="content">{children}</main>
    </>
  );
}

const AppRoutes = () => {
  const [open, setOpen] = useState(false);

  return (
    <Layout open={open} setOpen={setOpen}>
      <ReactNotifications id='notification' />
      <Routes>
        <Route path="/" element={<UserLogin />} />
        <Route path="/login" element={<UserLogin />} />
        <Route path="/home" element={<Home />} />
        <Route path="/brandsmodels" element={<BrandsModels />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/print" element={<PrintPage />} />
        <Route path="/vehicles" element={<Vehicles />} />
        {/* <Route path="/models" element={<Models />} /> */}
      </Routes>
    </Layout>
  );
}

const App = () => {
  return (
    <Router basename="/fpmotorhome">
      {/* <ReactNotifications id="notification" /> */}
      {/* <LoadingProvider /> */}
      <AppRoutes />
    </Router>
  );
}

export { App };
